import script from "./ManutMailAlertasTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutMailAlertasTabPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutMailAlertasTabPage.vue?vue&type=style&index=0&id=674fda9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674fda9e"]])

export default __exports__